import React, { FC } from 'react';
import { Props } from './types';
import * as Core from '../../core';

export const ConfirmationModal = <D, C>(props: Props<D, C>) => {
  const {
    cancelButtonText = 'Cancel',
    children,
    confirmButtonDisabled,
    confirmButtonText = 'Okay',
    confirmOnly = false,
    data,
    header,
    id = 'confirmation-modal',
    modalType = 'modal',
    onCancel,
    onClose,
    onConfirm,
    show,
    size = 'md',
    title,
    variant,
  } = props;

  const closeWithConfirm = e => {
    if (onConfirm) {
      onConfirm(props.data, e);
    }
  };

  const coreFooter = (
    <>
      {!confirmOnly && (
        <Core.Button
          data-action="cancel"
          id={`${id}-cancel-button`}
          onClick={onCancel}
          variant={Core.ButtonVariant.OUTLINE}
        >
          {cancelButtonText}
        </Core.Button>
      )}
      <Core.Button
        data-action="confirm"
        disabled={confirmButtonDisabled}
        id={`${id}-confirm-button`}
        onClick={closeWithConfirm}
        variant={Core.ButtonVariant.PRIMARY}
      >
        {confirmButtonText}
      </Core.Button>
    </>
  );
  return (
    <Core.Modal
      footer={coreFooter}
      header={header || title}
      id={id}
      isOpen={show === undefined ? !!data : show}
      modalType={modalType}
      onClose={onClose}
      showCloseButton={false}
      size={size}
      variant={variant}
    >
      {children}
    </Core.Modal>
  );
};

export default ConfirmationModal;
